<!-- IMAGE: NO ITEMS FOUND-->
<ng-container *ngIf="showNoItems">
  <div [attr.data-test-id]="'table-empty-result'" fxLayout="column" fxLayoutAlign="center center">
    <img src="assets/emtyState/notResults.svg" alt="No se encontraron Resultados" width="300" />
    <h1 class="centered p-32">{{textToShow}}</h1>
  </div>
</ng-container>
